import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { MasterdataService } from '../services/masterdata/masterdata.service';
import { HelpService } from '../services/helpservice/help.service';
import { UploaddocumentService } from '../services/uploaddocument/uploaddocument.service';
import { RegStatusCode } from '../enums/registration-statuscode.enum';
import { NewRegistrationService } from '../services/registration/newRegistration.service ';
import { NewRegistrationDataCollectionService } from '../services/registration/newRegistration-data-collection.service';
import { NewRegistrationsDetailsUpdate } from '../../registrations-data/services/newregistrations-details-update';
import { RegistrationModel } from '../../registrations-data/models/data/registration.model';
import { CodeDescriptionModel } from 'src/app/models/code-description.model';
import { RegistrationResponseByRegistrationIdModel } from 'src/app/registrations-data/models/response/registrations-response.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reason-for-update',
  templateUrl: './reason-for-update.component.html',
})

export class ReasonForUpdateComponent extends NewRegistrationsDetailsUpdate implements OnInit {

  // registrationForm$: Observable<RegistrationModel> = this.dataCollectionSvc.regFormObserv;
  // freshRegistrationInProgressModel$ = this.dataCollectionSvc.freshRegistrationInProgressModel$;
  registrationResponseModel$: Observable<RegistrationResponseByRegistrationIdModel> =
  this.registrationService.getRegistrations(this.activatedRoute.snapshot.params.registrationId);
  reasonForUpdateReg$ = this.masterdataService.reasonForUpdateReg$;
  regForm: RegistrationModel;
  subscribers: Subscription [] = [];
  checkOtherRevisionReasonIsNAN = false;
  @Output() reasonChange = new EventEmitter();

  constructor(dataCollectionSvc: NewRegistrationDataCollectionService,
              private registrationService: NewRegistrationService,
              private masterdataService: MasterdataService,
              public helpService: HelpService,
              uploaddocumentService: UploaddocumentService,
              private activatedRoute: ActivatedRoute) {
    super(dataCollectionSvc, helpService, uploaddocumentService);
  }

  ngOnInit() {
    this.subscribers.push(this.registrationResponseModel$.subscribe((responseData: RegistrationResponseByRegistrationIdModel) => {
      if (responseData) {
        this.registrationService.selectBuilding(responseData.buildingId);
        this.regForm = JSON.parse(responseData.data);
        this.dataCollectionSvc.setRegistration(this.regForm);
      }
    }));
    // this.freshRegistrationInProgressModel$.subscribe(data => {
    //   if (data) {
    //     this.dataCollectionSvc.setRegistration(data);
    //     // this.timelyAmendment(data);
    //   }
    // });
    // this.reasonForUpdateReg$.subscribe(reasons => {
    //   this.revisionReasons = reasons;
    // });
  }

  // Timely or untimely ammendment is checked based on Rent Stabilization date; remove OwnerInitiated
  timelyAmendment(reg: RegistrationModel): boolean {
    if (reg && reg.building && reg.building.stabilizedDate) {
      const rentStabilizedDate = reg.building.stabilizedDate;
      if (new Date((new Date(rentStabilizedDate).getFullYear() + 1) + '-07-31') < new Date()) {
        return true;
      }
    }
    return false;
  }

  // Filtering reasons based on the timely or untimely Secondary registrations.
  filterReasons(reasons, reg: RegistrationModel) {
    if (reasons) {
      const removeOwnerInitiated: boolean = this.timelyAmendment(reg);
      if (removeOwnerInitiated) {
        return (reasons.filter(returnCode => {
          return returnCode.code !== 'OwnerInitiated';
        }));
      }
    }
    return reasons;
  }

  // Cheking all the conditions before enabling the continue button
  shouldDisable(reg: RegistrationModel) {
    if (reg && reg.registrationForRevisionReason && reg.registrationForRevisionReason.code === 'OwnerInitiated') {
      return false;
    }
    if (reg && reg.registrationForRevisionReason && reg.registrationForRevisionReason.code === 'Other'
      && reg.otherRegistrationForRevisionReason !== null) {
      return false;
    }
    if (reg && reg.documents && reg.documents.length === 0) {
      return true;
    }
    if (reg && reg.registrationForRevisionReason && reg.registrationForRevisionReason.code !== null) {
      const attachment = (reg.documents || []).filter(att => att.documentType.code === reg.registrationForRevisionReason.code);
      if (!attachment || attachment.length === 0) {
        return true;
      }
    }
    return false;
  }

  onClick(reg: RegistrationModel, regResponseModel: RegistrationResponseByRegistrationIdModel) {
    // save the reg..
    if (reg && reg.registrationForRevisionReason && reg.registrationForRevisionReason.code === 'Other'
      && (reg.otherRegistrationForRevisionReason === null || reg.otherRegistrationForRevisionReason === undefined)) {
      this.checkOtherRevisionReasonIsNAN = true;
    } else {
      const showDiff = reg.registrationType.code === 'AMD' && reg.registrationStatus.code === RegStatusCode.INPROGRESS;
      const isAccepted = reg.registrationStatus.code === 'Accepted';
      this.registrationService.setMenuDetails(showDiff, isAccepted);
      this.dataCollectionSvc.setRegistration(reg);
      this.dataCollectionSvc.save(regResponseModel);
      this.reasonChange.emit();
    }
  }

  updateModel(reg: RegistrationModel, option: CodeDescriptionModel) {
    reg.registrationForRevisionReason = option;
  }
}
